import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Table } from 'reactstrap';

import AdminPageEditCollectionsListItem from './CollectionsListItem';

import withDragAndDropContext from '../../../helpers/withDragAndDropContext';

const AdminPageEditCollectionsList = ({
  collections,
  showTitle,
  showSubtitle,
  singleCollection,
  handleChangeCollection,
  handleDeleteCollection,
  handleMoveCollection,
}) => {
  const [dragging, setDragging] = useState(false);

  if (collections.length === 0) {
    return null;
  }

  return (
    <div className="table-wrapper">
      <Table className="users-list collections-list" responsive>
        <tbody className={classnames({ dragging })}>
          {collections.map(collection => (
            <AdminPageEditCollectionsListItem
              key={collection.id}
              index={collection.id}
              collection={collection}
              timestamp={collection.timestamp}
              canDrag={!singleCollection}
              moveCollection={handleMoveCollection}
              setDragging={setDragging}
              showTitle={showTitle}
              showSubtitle={showSubtitle}
              handleChangeCollection={handleChangeCollection}
              handleDeleteCollection={handleDeleteCollection}
            />
          ))}
        </tbody>
      </Table>
    </div>
  );
};

AdminPageEditCollectionsList.propTypes = {
  collections: PropTypes.array.isRequired,
  showTitle: PropTypes.bool,
  showSubtitle: PropTypes.bool,
  singleCollection: PropTypes.bool,
  handleChangeCollection: PropTypes.func.isRequired,
  handleDeleteCollection: PropTypes.func.isRequired,
  handleMoveCollection: PropTypes.func,
};

AdminPageEditCollectionsList.defaultProps = {
  showTitle: true,
  showSubtitle: true,
  singleCollection: false,
  handleMoveCollection: () => {},
};

export default withDragAndDropContext(AdminPageEditCollectionsList);
